/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import typography from '../typography';

export default {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            fontFamily: typography.button.fontFamily,
        },
    },
};
